/**
 * ChiliPiperDS event listeners — push dataLayer events for GTM/GA4.
 *
 * Events sent to dataLayer:
 *   ds3_info_submit          ← HS form submit (ChiliPiperDS/index.js dispatches)
 *   ds3_scheduled            ← qualified Meeting Booked (also fires lintrk + Optimizely)
 *   ds3_conversation_started ← qualified Conversation Started
 *   ds3_email_captured       ← qualified Email Captured
 *
 * Backend sends (Tray + ESB) fire off qualified Workflow Meeting Booked.
 * No GA4 push there — Meeting Booked already covers it.
 *
 * Debug: ?thryvDebug=ds3 or ?thryvDebug=ChiliPiperEvents
 */
var ChiliPiperDS_Events = new Object();

ChiliPiperDS_Events.version = '1.0.0';

ChiliPiperDS_Events.listen = function ($el)
{
  console.log('[ChiliPiperDS.Events] listen', $el);

  helpers.listenEvent('ds3_info_submit', function (detail)
  {
    // var nameArr = helpers.splitFullName(data.full_name);
    // console.log('detail', detail);
    // console.log('nameArr', nameArr);
    var dataLayerData = helpers.dlSanitize({
      event: 'ds3_info_submit',
      event_name: 'ds3_info_submit',
      click_url: window.location.href,

      // User data (must match your GTM DLV variable names)
      fname: helpers.splitFullName(detail.full_name)['first'],
      lname: helpers.splitFullName(detail.full_name)['last'],
      email: detail.email,
      phone: detail.phone,

      // Extra identifiers
      // hubspot_id: formData.hubspotId,
      event_id: crypto.randomUUID(),
      page_url: window.location.href,

      // Meta cookies (already exist client-side, but you can send explicitly too)
      fbp: Cookies.get('_fbp'),
      fbc: Cookies.get('_fbc')

    });

    if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.Events] ds3_info_submit dataLayerData:', dataLayerData);

    dataLayer.push(dataLayerData);

    window.lintrk && window.lintrk('track', { conversion_id: 10868140 });

    // TikTok Lead event
    window.ttq && window.ttq.track('Lead');

    window['optimizely'] = window['optimizely'] || [];
    window['optimizely'].push({
      type: "event",
      eventName: "Demo Info Submitted"
    });

  });

  // Use native document.addEventListener for Chili Piper events (matches
  // how ThryvQualified.Events dispatches and listens on its own analytics
  // side — single bus, no helper-wrapper indirection).
  window.addEventListener("message", function (event)
  {
    var data = event.data;

    // Ensure the message comes from Chili Piper scheduling
    if (!data || data.type !== "CHILI_SCHEDULING_EVENT") return;
    var action = data.action;

    // Check specific booking actions
    switch (action) 
    {
      // The "booking-confirmed" listener waits for the second booking confirmation 
      // screen to be displayed at the end of the booking workflow. This event will
      // include the meeting information and the eventId.
      case "booking-confirmed":
        if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.Events] booking-confirmed received:', data);

        // Chili Piper Concierge Events puts visitor data under data
        var nameParts = helpers.splitFullName(data.full_name);

        var dataLayerData = helpers.dlSanitize({
          event: 'ds3_scheduled',
          event_name: 'ds3_scheduled',
          click_url: window.location.href,

          // User data (must match your GTM DLV variable names)
          // fname: nameParts['first'],
          // lname: nameParts['last'],
          // email: data.email,
          // phone: data.phone_input_only,

          // Extra identifiers
          event_id: crypto.randomUUID(),
          page_url: window.location.href,

          // Meta cookies (already exist client-side, but you can send explicitly too)
          fbp: Cookies.get('_fbp'),
          fbc: Cookies.get('_fbc')

        });

        if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.Events] ds3_scheduled dataLayerData:', dataLayerData);

        dataLayer.push(dataLayerData);

        window.lintrk('track', { conversion_id: 2101010 });

        window['optimizely'] = window['optimizely'] || [];
        window['optimizely'].push({
          type: "event",
          eventName: "Demo Scheduled"
        });
        break;

      // The "live_chat_started" listener is a chat only event listener
      // that fires when a rep has joined the conversation.
      case "live_chat_started":
        if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.Events] live_chat_started received:', data);

        var dataLayerData = helpers.dlSanitize({
          event: 'ds3_conversation_started',
          event_name: 'ds3_conversation_started',
          click_url: window.location.href,

          // User data (must match your GTM DLV variable names)
          // fname: helpers.splitFullName(data.full_name)['first'],
          // lname: helpers.splitFullName(data.full_name)['last'],
          // email: data.email,
          // phone: data.phone,

          // Extra identifiers
          // hubspot_id: formData.hubspotId,
          event_id: crypto.randomUUID(),
          page_url: window.location.href,

          // Meta cookies (already exist client-side, but you can send explicitly too)
          fbp: Cookies.get('_fbp'),
          fbc: Cookies.get('_fbc'),

        });

        if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.Events] ds3_conversation_started dataLayerData:', dataLayerData);

        dataLayer.push(dataLayerData);
        break;

      // The "data-captured" listener is a chat only event listener that fires when a 
      // visitor submits data from data fields sent OR submits data when booking a meeting
      // via suggested times. This event will also contain submitted formData as an argument.
      case "data-captured":
        if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.Events] data-captured received:', data);

        var nameParts = helpers.splitFullName(data.name);

        var dataLayerData = helpers.dlSanitize({
          event: 'ds3_email_captured',
          event_name: 'ds3_email_captured',
          click_url: window.location.href,
          page_url: window.location.href,
          event_id: crypto.randomUUID(),
          fname: nameParts['first'],
          lname: nameParts['last'],
          email: data.email,
          phone: data.phone_input_only,
          fbp: Cookies.get('_fbp'),
          fbc: Cookies.get('_fbc'),
        });

        if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.Events] ds3_email_captured dataLayerData:', dataLayerData);

        dataLayer.push(dataLayerData);
        break;
    }
  });
};

export default ChiliPiperDS_Events;